export default __webpack_public_path__ + "static/ue-logo-3-3f9ff834b75976535e21a699f34b1fbd.svg";